<form [formGroup]="registerForm" (ngSubmit)="register()">
  <div class="row">
    <div class="form-group col-md-4">
      <label>First name</label>
      <input class="form-control" [ngClass]="setClassInvalid(registerForm, 'firstName')" type="text" name="First name"
        formControlName="firstName" placeholder="First name" maxlength="30" required>
    </div>
    <div class="form-group col-md-4">
      <label>Last name</label>
      <input class="form-control" [ngClass]="setClassInvalid(registerForm, 'lastName')" type="text" name="Last name"
        formControlName="lastName" placeholder="Last name" maxlength="30" required>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-8">
      <label>Email</label>
      <input class="form-control" [ngClass]="setClassInvalid(registerForm, 'email')" type="email" name="Email"
        formControlName="email" placeholder="Email" minlength="3" maxlength="100" autocomplete="email" required>
      <div class="invalid-feedback">Invalid email.</div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>Department</label>
      <select class="form-control" [ngClass]="setClassInvalid(registerForm, 'department')" name="department"
        formControlName="department" required>
        <option value="" selected disabled>Select department</option>
        @for (department of departments; track department) {
          <option [value]="department">{{department}}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-4">
      <label>Site</label>
      <select class="form-control" [ngClass]="setClassInvalid(registerForm, 'site')" name="site"
        formControlName="site" required>
        <option value="" selected disabled>Select site</option>
        @for (site of sites; track site) {
          <option [value]="site">{{site}}</option>
        }
      </select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-8">
      <label>Password</label>
      <div class="input-group">
        <input class="form-control" [ngClass]="setClassInvalid(registerForm, 'password')" [type]="inputPasswordType" name="password"
          formControlName="password" placeholder="Password" minlength="8" autocomplete="new-password" required>
        <div class="input-group-append cursor-pointer" (click)="toggleInputPasswordType()"
          data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Show/Hide password">
          <span class="input-group-text">
            <i class="fa" [ngClass]="{'fa-eye': inputPasswordType === 'password', 'fa-eye-slash': inputPasswordType === 'text' }"></i>
          </span>
        </div>
        <div class="invalid-feedback">Password must be 8+ chars and include 1 uppercase char, 1 lowercase char and 1 number.</div>
      </div>
    </div>
  </div>
  <p class="small">Already have an account? <a routerLink="/login">Login here</a>.</p>
  <button class="btn btn-primary" type="submit" [disabled]="!registerForm.valid">
    <i class="fa fa-user-plus"></i> Register
  </button>
</form>